import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    class: "siteSearch-hit",
    "data-hit": "dealer"
};
const _hoisted_2 = { class: "dealer-row" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    key: 0,
    class: "dealer-row"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
    key: 1,
    class: "dealer-row"
};
const _hoisted_9 = { key: 0 };
const _hoisted_10 = ["href"];
const _hoisted_11 = { key: 1 };
const _hoisted_12 = ["href"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'Dealer',
    props: {
        document: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            var _a, _b, _c, _d;
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", {
                        class: "dealer-country",
                        innerHTML: ((_a = _ctx.document._formatted) === null || _a === void 0 ? void 0 : _a.country) || _ctx.document.country
                    }, null, 8, _hoisted_3),
                    _createElementVNode("h3", {
                        class: "dealer-title",
                        innerHTML: ((_b = _ctx.document._formatted) === null || _b === void 0 ? void 0 : _b.title) || _ctx.document.title
                    }, null, 8, _hoisted_4),
                    (_ctx.document.department)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "dealer-department",
                            innerHTML: ((_c = _ctx.document._formatted) === null || _c === void 0 ? void 0 : _c.department) || _ctx.document.department
                        }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.document.address)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", {
                            class: "dealer-address",
                            innerHTML: ((_d = _ctx.document._formatted) === null || _d === void 0 ? void 0 : _d.address) || _ctx.document.address
                        }, null, 8, _hoisted_7)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.document.phone || _ctx.document.email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_ctx.document.phone)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                _createElementVNode("a", {
                                    class: "dealer-link",
                                    href: `tel:${_ctx.document.phone.replace(/\D/g, '')}`
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.document.phone), 1)
                                ], 8, _hoisted_10)
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.document.email)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                                _createElementVNode("a", {
                                    class: "dealer-link",
                                    href: `mailto:${_ctx.document.email}`
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.document.email), 1)
                                ], 8, _hoisted_12)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
